import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import CareerTimeline from "@/components/site/CareerTimeline";
import Stats from "@/components/site/Stats";
import Philosophy from "@/components/site/Philosophy";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Home = () => (
  <div className="bg-[#050505] text-white min-h-screen" data-testid="home-page">
    <div className="grain" />
    <Navbar />
    <main>
      <Hero />
      <About />
      <CareerTimeline />
      <Stats />
      <Philosophy />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid #262626",
            color: "#ffffff",
            borderRadius: "0",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
